module.exports = __webpack_public_path__ + "img/1-4@2x.037bb242.png";